import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/shared/authentication/authentication.service';
import { ResetPassword } from 'app/shared/models/reset-password.model';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  resetPassword: ResetPassword
  token: string
  protected resetPasswordMessage: string;

  constructor(private authenticationService: AuthenticationService, private router: Router, private activatedRoute: ActivatedRoute, protected translateService: TranslateService) {
  }

  ngOnInit() {
    if (this.authenticationService.isAuthenticated) {
      this.authenticationService.logout(false);
    }

    this.initializeObject();
    this.translateService.get(['account.resetPassword.resetPasswordMessage'])
      .subscribe(translations => {
        this.resetPasswordMessage = translations['account.resetPassword.resetPasswordMessage'];
      });

    this.activatedRoute.queryParams
      .subscribe(params => {
        this.resetPassword.Email = params['email'];
        this.resetPassword.Code = params['token'];
      });
  }

  initializeObject() {
    if (this.resetPassword == null) {
      this.resetPassword = new ResetPassword();
    }
  }

  onSubmit(form: NgForm) {
    this.authenticationService.resetPassword(form.value, () => this.router.navigate(['/account/login']), this.resetPasswordMessage);
  }
}
